import theme from '@/theme'
import React from 'react'

export default function Space({ height = 20 }: { height?: number }) {
    return <div style={{ width: '100%', height, backgroundColor: theme.colors.white }} />
}
